import { createInertiaApp } from "@inertiajs/svelte";

import "vite/modulepreload-polyfill";
import "../styling/main.css";

createInertiaApp( {
    resolve: name => {
        const pages = import.meta.glob( './pages/**/*.svelte', { eager: true } );
        return pages[ `./pages/${name}.svelte` ] as any;
    },
    setup( { el, App, props } ) {
        new App( { target: el } );
    },
} );
